var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  YayoyakiValidator: () => YayoyakiValidator
});
var import_papaya = __toModule(require("@taxdown/papaya"));
var import_errorMessages = __toModule(require("../errorMessages"));
class YayoyakiValidator {
  static validateRequirements(userData, requirements, multidimensionalKey = void 0) {
    const isValid = import_papaya.default.engine.expression.evaluate(userData, requirements, multidimensionalKey);
    return Array.isArray(isValid) && multidimensionalKey !== void 0 ? isValid[multidimensionalKey] : isValid;
  }
  static validateRequirementsSafe(userData, requirements, multidimensionalKey) {
    try {
      return this.validateRequirements(userData, requirements, multidimensionalKey);
    } catch (error) {
      return true;
    }
  }
  static evaluateExpression(userData, requirements) {
    if (!requirements) {
      return true;
    }
    return import_papaya.default.engine.expression.evaluate(userData, requirements);
  }
  static getInputValidations(input) {
    const { validations = {}, options } = input;
    if (options) {
      const formatedOptions = options.map((option) => option.value);
      validations.options = formatedOptions;
    }
    return validations;
  }
  static isFieldValid(fieldValue, input) {
    const validations = this.getInputValidations(input);
    const validRef = this.getRef(input);
    return validRef.validate(fieldValue, validations);
  }
  static getFieldValidationMessage(fieldValue, input) {
    if (!this.isFieldValid(fieldValue, input)) {
      const validations = this.getInputValidations(input);
      const validRef = this.getRef(input);
      const message = import_errorMessages.ERROR_MESSAGE[validRef.message(fieldValue, validations, false)];
      return message.replace(/{{([a-z]+)}}/, (_match, p1) => {
        const validateValue = validations[p1.replace(/[{}]/g)];
        if (validRef.NAME === "Date" && validateValue.length === 8) {
          return validateValue.substring(0, 2) + "/" + validateValue.substring(2, 4) + "/" + validateValue.substring(4, 8);
        }
        return validateValue;
      });
    }
  }
  static getFieldDefault(input) {
    const validRef = this.getRef(input);
    return validRef.getDefaultValue();
  }
  static isFieldDefault(fieldValue, input) {
    return fieldValue === this.getFieldDefault(input);
  }
}
YayoyakiValidator.getRef = (input) => {
  const { validationType } = input;
  return import_papaya.default.model.TYPES[validationType];
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  YayoyakiValidator
});
